// extracted by mini-css-extract-plugin
export default {"ProcessFormModal":"ProcessFormModal_ProcessFormModal__nN4XW"};